import React, { useEffect, useState } from "react";
import { getInquiries } from "../services/inquiryService";

const InquiriesPage = () => {
  const [inquiries, setInquiries] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchInquiries = async () => {
    setLoading(true);
    try {
      const res = await getInquiries();
      // сортуємо від нових до старих
      const sorted = res.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setInquiries(sorted);
    } catch (err) {
      console.error("Помилка при завантаженні запитів:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInquiries();
  }, []);

  // фільтруємо запити за останню добу
  const inquiriesToShow = showAll
    ? inquiries
    : inquiries.filter((i) => {
        const oneDayAgo = new Date();
        oneDayAgo.setDate(oneDayAgo.getDate() - 1);
        return new Date(i.createdAt) >= oneDayAgo;
      });

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">Запити користувачів</h2>

      <button
        onClick={() => setShowAll(!showAll)}
        className="mb-4 px-4 py-2 rounded bg-[#4A3B30] text-white hover:bg-[#3A2C23]"
      >
        {showAll ? "Показати останню добу" : "Показати всі"}
      </button>

      {loading ? (
        <p>Завантаження...</p>
      ) : (
        <table className="w-full border-collapse border">
          <thead>
            <tr className="bg-[#EDE0D4] text-[#4A3B30]">
              <th className="p-2 border">Ім’я</th>
              <th className="p-2 border">Телефон</th>
              <th className="p-2 border">Питання</th>
              <th className="p-2 border">Дата</th>
            </tr>
          </thead>
          <tbody>
            {inquiriesToShow.map((i) => (
              <tr key={i.id}>
                <td className="p-2 border">{i.name}</td>
                <td className="p-2 border">{i.phone}</td>
                <td className="p-2 border">{i.question}</td>
                <td className="p-2 border">{new Date(i.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default InquiriesPage;
